// extracted by mini-css-extract-plugin
export default {"buttonWindow":"ButtonWindow_buttonWindow__mg5Dp"};